import { render, staticRenderFns } from "./ButtonRound.vue?vue&type=template&id=364bf4f6&scoped=true"
import script from "./ButtonRound.vue?vue&type=script&lang=ts"
export * from "./ButtonRound.vue?vue&type=script&lang=ts"
import style0 from "./ButtonRound.vue?vue&type=style&index=0&id=364bf4f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364bf4f6",
  null
  
)

export default component.exports